<template>
    <div id="main-menu">
        <router-link to="/">Home</router-link> | 
        <router-link to="/about">About</router-link> | 
        <router-link to="/auth/login">Login</router-link> | 
        <router-link to="/auth/registration">Registration</router-link>        
    </div>
</template>

<script>
export default {
    name: "top-menu",
    data() {
        return{
            counter: 1
            }
    }
}
</script>